// Sentinel emitted by the backend while learning agents are still computing a
// value. Must match `ANALYZING_PLACEHOLDER` in apps/reasoning/services/insights.py
// (three literal ASCII dots — never the ellipsis character).
// Comparisons against stored/backend values must always use this constant.
export const ANALYZING_PLACEHOLDER = 'Analyzing...';

// Customer-facing rendering of the sentinel above — uses the typographic
// ellipsis character (…) for display only. Never use this for comparisons.
export const ANALYZING_PLACEHOLDER_DISPLAY = 'Analyzing…';
